var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareBoxOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.5 4l9.5 8l-9.5 8v-5.1c-5 0-8.5 1.6-11 5.1c1-5 4-10 11-11z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "m12.5 4l9.5 8l-9.5 8v-5.1c-5 0-8.5 1.6-11 5.1c1-5 4-10 11-11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareBoxOutlined);
export default __webpack_public_path__ + "static/media/share-box-outlined.d2dd81922897a5e6b6e34111274dc58c.svg";
export { ForwardRef as ReactComponent };